import { ElectricalMeterType } from '../electrical-meter.service';
import { WaterMeterType } from '../water-meter.service';

export const MeterTypes = {
  electrical: ElectricalMeterType,
  water: WaterMeterType,
};
